// frontend/src/components/layout/FloatingSocialBar.js
import { FaDiscord, FaYoutube, FaTiktok } from "react-icons/fa";

import { trackSocialClick } from "../../analytics/analytics";

export default function FloatingSocialBar() {
  const items = [
    {
      icon: <FaDiscord />,
      label: "Discord",
      platform: "discord",
      color: "#5865F2",
      href: "https://discord.gg/b2PwP23aH3",
    },
    {
      icon: <FaYoutube />,
      label: "YouTube",
      platform: "youtube",
      color: "#ff0000",
      href: "https://youtube.com/@LightBorn68",
    },
    {
      icon: <FaTiktok />,
      label: "TikTok",
      platform: "tiktok",
      color: "#111",
      href: "https://www.tiktok.com/@lightborn_68",
    },
  ];

  function handleClick(item) {
    trackSocialClick(item.platform, item.href);
  }

  return (
    <div className="panel-social-bar">
      {items.map((item) => (
        <a
          key={item.label}
          href={item.href}
          target="_blank"
          rel="noreferrer"
          className="panel-social-item"
          onClick={() => handleClick(item)}
        >
          <span
            className="panel-social-label"
            style={{
              background: item.color,
            }}
          >
            {item.label}
          </span>

          <span
            className="panel-social-icon"
            style={{
              background: item.color,
            }}
          >
            {item.icon}
          </span>
        </a>
      ))}
    </div>
  );
}
